import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Sparkles, AlertCircle } from 'lucide-react';
import api, { setToken } from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import OrgPicker from '../components/OrgPicker';

export default function MagicVerify() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const [orgChoice, setOrgChoice] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const token = params.get('token');
    if (!token) {
      setError('Lien invalide');
      return;
    }
    (async () => {
      try {
        const { data } = await api.post('/auth/magic-link/verify', { token });
        if (data.requires_org_choice && data.challenge) {
          setOrgChoice(data);
          return;
        }
        if (data.session_token) setToken(data.session_token);
        setUser(data.user);
        navigate('/app', { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || 'Lien invalide ou expiré');
      }
    })();
  }, [params, navigate, setUser]);

  if (orgChoice) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-6">
        <div className="w-full max-w-[420px]">
          <OrgPicker choice={orgChoice} onBack={() => navigate('/login', { replace: true })} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="max-w-[380px] text-center px-6">
          <div className="w-14 h-14 rounded-2xl bg-[#FEF2F2] flex items-center justify-center mx-auto">
            <AlertCircle className="w-7 h-7 text-[#EF4444]" />
          </div>
          <h1 className="mt-4 text-[20px] font-bold text-[#1A1B2E]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Connexion impossible</h1>
          <p className="mt-2 text-[13.5px] text-[#6B6C85]">{error}</p>
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="mt-5 h-10 px-5 rounded-xl brand-gradient text-white text-[13px] font-semibold"
          >
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-14 h-14 rounded-2xl brand-gradient flex items-center justify-center mx-auto animate-pulse">
          <Sparkles className="w-7 h-7 text-white" />
        </div>
        <p className="mt-4 text-[14px] text-[#4A4B63]">Vérification du lien…</p>
      </div>
    </div>
  );
}
